import { Path } from "react-native-svg";
import styled from "styled-components/native";

export const PathWithNoOutline = styled(Path)`
  outline-style: none;
`;
